import { Injectable, inject } from '@angular/core';
import { AuthFacade } from '@core/facades/auth.facade';
import { MemberFacade } from '@core/facades/member.facade';
import { AppLanguageService } from '@core/services/app-language.service';
import { PushNotificationsService } from '@core/services/push-notifications.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionBootstrapService {
  private readonly auth = inject(AuthFacade);
  private readonly memberFacade = inject(MemberFacade);
  private readonly appLanguage = inject(AppLanguageService);
  private readonly push = inject(PushNotificationsService);

  private readonly subscriptions = new Subscription();

  init(): void {
    this.push.init();
    this.subscriptions.add(
      this.memberFacade.memberState$
        .pipe(
          distinctUntilChanged(
            (a, b) =>
              a.status === b.status &&
              (a.data?.memberId ?? null) === (b.data?.memberId ?? null) &&
              (a.data?.language ?? null) === (b.data?.language ?? null),
          ),
        )
        .subscribe((state) => {
          if (state.status === 'loading') return;
          void this.appLanguage.applyStoredLanguage(state.data?.language ?? 'DE');
        }),
    );

    this.subscriptions.add(
      this.auth.user$
        .pipe(distinctUntilChanged((a, b) => (a?.id ?? null) === (b?.id ?? null)))
        .subscribe((user) => {
          this.memberFacade.setAuthUser(user);
        }),
    );
  }
}
